export default __webpack_public_path__ + "static/media/PROMO DE VERDADE.685ed59b.png";